/**
 * @file Photos related mutations.
 */

import gql from 'graphql-tag';

export const photosUpload = gql`
  mutation photosUpload($input: PhotosUploadInput!) {
    photosUpload(input: $input) {
      photo_uploads {
        photo_id
        upload_url
      }
    }
  }
`;
